export const UNKNOWN_FILETYPE = "Unknown filetype";

export const getMimeType = async (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const filereader = new FileReader();
        filereader.onloadend = function(evt: ProgressEvent<FileReader>) {
            if (evt.target && evt.target.result && evt.target.result instanceof ArrayBuffer) {
                if (evt.target.readyState === FileReader.DONE) {
                    const uint = new Uint8Array(evt.target.result);
                    const bytes: string[] = [];
                    uint.forEach(byte => {
                        bytes.push(byte.toString(16));
                    });
                    const hex = bytes.join("").toUpperCase();

                    switch (hex) {
                        case "89504E47":
                            resolve("image/png");
                            break;
                        case "25504446":
                            resolve("application/pdf");
                            break;
                        case "FFD8FFDB":
                        case "FFD8FFE0":
                        case "FFD8FFEE":
                        case "FFD8FFE1":
                            resolve("image/jpeg");
                            break;
                        default:
                            resolve(UNKNOWN_FILETYPE);
                    }
                }
            }
        };

        filereader.onerror = function(evt: ProgressEvent<FileReader>) {
            if (evt.target && evt.target.error) {
                reject(evt.target.error.message);
            } else {
                reject("inspecting file failed");
            }
        };

        const blob = file.slice(0, 4);
        filereader.readAsArrayBuffer(blob);
    });
};

const sizeUnits = ["B", "kB", "MB"];
export const formatFileSize = (size: number, divisions = 0): string => {
    if (size < 1024 || divisions === sizeUnits.length - 1) {
        return `${size.toFixed(1)} ${sizeUnits[divisions]}`;
    } else {
        return formatFileSize(size / 1024, ++divisions);
    }
};
